<template>
  <RevCard class="p-24">
    <div class="mb-24 flex items-center justify-between">
      <div class="heading-2 flex items-center gap-8">
        <IconSwap />
        {{ i18n(translations.tradeIn) }}
      </div>

      <div class="flex items-center gap-24">
        {{ i18n(translations.lastSevenDays) }}

        <RevButton
          size="small"
          :to="{ name: ROUTE_NAMES.BUYBACK.ORDERS.ACTIVE }"
          variant="secondary"
        >
          {{ i18n(translations.viewDetails) }}
        </RevButton>
      </div>
    </div>

    <div>
      <RevLoadingScreen
        v-if="isLoading"
        class="mt-32"
        :text="i18n(translations.loading)"
      />

      <div v-else class="grid grid-cols-2 gap-24">
        <div
          class="border-static-default-mid rounded-sm flex w-full flex-col justify-between gap-12 border p-24"
        >
          <div class="body-1 flex items-start gap-8">
            <IconTruck />
            {{ i18n(translations.ordersOnTheMove) }}
          </div>

          <div class="mt-24">
            <div>
              <span class="heading-2 mr-4">
                {{ refurbisherInsights?.orders.shipped }}
              </span>
              {{ i18n(translations.shipped) }}
            </div>

            <div>
              <span class="heading-2 mr-4">
                {{ refurbisherInsights?.orders.delivered }}
              </span>
              {{ i18n(translations.delivered) }}
            </div>
          </div>
        </div>

        <div
          class="border-static-default-mid rounded-sm flex w-full flex-col justify-between gap-12 border p-24"
        >
          <p class="body-1 flex items-start gap-8">
            <IconInfo />
            {{ i18n(translations.ordersRequireAction) }}
          </p>

          <div class="mt-24">
            <div>
              <span class="heading-2 mr-4">
                {{ refurbisherInsights?.orders.toBeProcessed }}
              </span>
              {{ i18n(translations.toProcess) }}
            </div>

            <div>
              <span class="heading-2 mr-4">
                {{ refurbisherInsights?.orders.pendingReply }}
              </span>
              {{ i18n(translations.toReplyTo) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { type Error, getApiErrorMessage } from '#imports'

import { getRefurbisherInsights } from '@backmarket/http-api/src/api-specs-buyback/seller/refurbisher'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'
import { IconInfo } from '@ds/icons/IconInfo'
import { IconSwap } from '@ds/icons/IconSwap'
import { IconTruck } from '@ds/icons/IconTruck'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './TradeIn.translations'

const i18n = useI18n()
const { openErrorToast } = useTheToast()

const {
  data: refurbisherInsights,
  error,
  pending: isLoading,
} = await useHttpFetch(getRefurbisherInsights)

if (error.value) {
  openErrorToast({
    content: getApiErrorMessage(error.value as unknown as Error),
  })
}
</script>
